import { Chip, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { VARIANT_COPY } from '../../config';
import * as SX from './sx';
import type { CurrentPlanHeaderProps as Props } from './types';
import { Dot } from '@aibees/shared/components/dot';

export const CurrentPlanHeader = memo(
  ({ plan, open, onToggle, className }: Props) => {
    const copy = VARIANT_COPY[plan.variant];

    return (
      <Box className={classnames('CurrentPlanHeader', className)} sx={SX.root}>
        <Stack sx={SX.content}>
          <Box>
            <Chip
              label="Your Current Plan"
              color="primary"
              variant="outlined"
              shape="rounded"
              size="small"
              icon={<Dot sx={SX.dot} />}
            />
          </Box>
          <Typography variant="h4" color="grey.900">
            {copy.title}
          </Typography>
          <Box sx={SX.subtitleRow}>
            <Typography variant="body3" fontWeight={700} color="primary.main">
              {copy.summaryTitle}
            </Typography>
            <Box sx={SX.subtitleDot} />
            <Typography variant="body3" fontWeight={400} color="grey.600">
              {plan.credits.replace('/ Month', 'Credits / Month').trim()}
            </Typography>
            <Box sx={SX.subtitleDot} />
            <Typography variant="body3" fontWeight={400} color="grey.600">
              {plan.seats}
            </Typography>
            <Box sx={SX.subtitleDot} />
            <Typography variant="body3" fontWeight={400} color="grey.600">
              ${plan.price} {plan.monthLabel}
            </Typography>
          </Box>
        </Stack>
        <Button
          variant={open ? 'outlined' : 'contained'}
          color="primary"
          size="small"
          onClick={onToggle}
          endIcon={
            <Icon name={open ? 'chevron-up' : 'chevron-down'} size={16} />
          }
        >
          {open ? 'Hide Details' : 'Show Details'}
        </Button>
      </Box>
    );
  }
);

CurrentPlanHeader.displayName = 'CurrentPlanHeader';
